import PropTypes from "prop-types";
import React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";

class OrderConfirmation extends React.Component {
  constructor(props) {
    super(props);
  }
  
  render() {
    const {
      lastLoanNumber,
    } = this.props;
    
    return (
      <div className="case-header">
        <Card>
          <CardContent><Typography variant="h6">Thank you for your order</Typography></CardContent>
          <CardContent className="md-grid">
            Your loan number is {lastLoanNumber}. You will receive a confirmation e-mail shortly. 
          </CardContent>
        </Card>
      </div>
    );
  }
}

OrderConfirmation.propTypes = {
  lastLoanNumber: PropTypes.string.isRequired
};

export default OrderConfirmation;
